import React from 'react';
import { useTranslation } from 'react-i18next';
import BubbleButton from '../../../Buttons/BubbleButton/BubbleButton';
import styles from './ContactPopup.module.css';

/**
 * Success message component for the contact popup
 */
const SuccessMessage = ({ onClose }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <p className={styles.successMessage}>
        {t('ContactPopup.success_message')}
      </p>
      <div className={styles.buttons}>
        <BubbleButton 
          onClick={onClose}
          headerButton
        >
          {t('general.UI.close')}
        </BubbleButton>
      </div>
    </>
  );
};

export default SuccessMessage; 